import { EmptyView } from '@shared/components/ui/EmptyView';
import { useTranslation } from 'react-i18next';
import { ReceptionListItem } from '../../models/Reception';
import { ReceptionCard } from './ReceptionCard';

interface ReceptionCardListProps {
  receptions: ReceptionListItem[];
  onEdit: (reception: ReceptionListItem) => void;
  onDelete: (reception: ReceptionListItem) => void;
  hasActiveFilters?: boolean;
  hasSearchTerm?: boolean;
  onCreateReception?: () => void;
  canEdit?: boolean;
  canDelete?: boolean;
}

/**
 * Lista de tarjetas de recepciones para vista móvil
 */
export const ReceptionCardList: React.FC<ReceptionCardListProps> = ({
  receptions,
  onEdit,
  onDelete,
  hasActiveFilters = false,
  hasSearchTerm = false,
  onCreateReception,
  canEdit = true,
  canDelete = true,
}) => {
  const { t } = useTranslation('receptionsModule');

  if (receptions.length === 0) {
    if (hasActiveFilters || hasSearchTerm) {
      return <EmptyView title={t('no_results.title')} description={t('no_results.description')} />;
    }
    return (
      <EmptyView
        title={t('empty_state.title')}
        description={t('empty_state.description')}
        buttonText={t('button.create')}
        onButtonClick={onCreateReception}
      />
    );
  }

  return (
    <div className="space-y-2 sm:space-y-3">
      {receptions.map((reception) => (
        <ReceptionCard
          key={reception.id}
          reception={reception}
          onEdit={canEdit ? onEdit : undefined}
          onDelete={canDelete ? onDelete : undefined}
        />
      ))}
    </div>
  );
};

export default ReceptionCardList;
